import { AppPaths } from "@p0security/shared/routes/constants";
import { Button } from "antd";
import React, { useCallback } from "react";
import { useParams } from "react-router";

import { useNavigateWithSearchParams } from "../../Assessment/hooks/useNavigateWithSearchParams";

const SkipOnboardingButton = React.memo(
  ({ textOverride }: { textOverride?: string }) => {
    const navigateWithSearchParams = useNavigateWithSearchParams();
    const { orgSlug } = useParams();

    const handleSkip = useCallback(() => {
      navigateWithSearchParams(`/o/${orgSlug}/${AppPaths.Dashboard}`);
    }, [navigateWithSearchParams, orgSlug]);

    return (
      <Button type="link" onClick={handleSkip} style={{ padding: 0 }}>
        {textOverride || "Skip onboarding"}
      </Button>
    );
  }
);

SkipOnboardingButton.displayName = "SkipOnboardingButton";

export { SkipOnboardingButton };
